import { create } from 'zustand';
import type { GeneratedLocation, District } from '@bid/shared-types';
import { generateLocation } from '@bid/bitd-data';
import { saveContent } from '@bid/client-storage';

interface LocationStore {
  generatedLocation: GeneratedLocation | null;
  selectedDistrict: District | null;
  isGenerating: boolean;
  generateLocation: () => void;
  setDistrict: (district: District | null) => void;
  saveLocation: () => Promise<number | null>;
}

export const useLocationStore = create<LocationStore>((set, get) => ({
  generatedLocation: null,
  selectedDistrict: null,
  isGenerating: false,

  generateLocation: () => {
    set({ isGenerating: true });
    const { selectedDistrict } = get();

    const location = generateLocation({
      district: selectedDistrict || undefined,
    });

    set({
      generatedLocation: location,
      isGenerating: false,
    });
  },

  setDistrict: district => {
    set({ selectedDistrict: district });
  },

  saveLocation: async () => {
    const { generatedLocation } = get();
    if (generatedLocation) {
      try {
        const id = await saveContent('location', generatedLocation.name, generatedLocation);
        console.log('Location saved with ID:', id);
        return id;
      } catch (error) {
        console.error('Error saving location:', error);
        return null;
      }
    }
    return null;
  },
}));
